import * as React from 'react'
import { BPMChart } from '../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../api'
import { Series, ArgumentAxis, Label, TickInterval } from 'devextreme-react/chart'
import { GroupByDate, GroupByDateType } from '../../../components/GroupByDate'
import { resultDateTransformer } from '../../../utils/date'
import { Colors } from '../../../utils/corlor'

export const SessionChart: React.FunctionComponent<{}> = () => {

    const color = Colors[0]
    const [groupDateBy, setGroupDateBy] = React.useState<GroupByDateType>('day')
    return (
        <BPMChart title='Sessions' subTitle='Active Users over Time' type='spline'
            additionalParams={{ groupDateBy }}
            onRequestLoad={(options, signal) => {
                return resultDateTransformer(BPMAnalyticsAPI.get<any>('sessions', options, signal))
            }} toolBarItems={() => GroupByDate(groupDateBy, (selected) => {
                setGroupDateBy(selected)
            })}>
            <Series
                valueField="count"
                argumentField="date" name='Sessions'
                color={color}>
            </Series>
            <ArgumentAxis>
                <Label format={groupDateBy == 'month' ? 'month' : "shortDate"} />
                <TickInterval days={groupDateBy == 'day' ? 1 : undefined}
                    weeks={groupDateBy == 'week' ? 1 : undefined}
                    months={groupDateBy == 'month' ? 1 : undefined} />
            </ArgumentAxis>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Dashboard/charts/SessionChart.tsx